<template>
    <div class="h-full">
        <input type="file" id="fileInput" style="visibility: hidden">
        <ai-grid-edit
            v-if="isDataLoaded"
            ref="gridRef"
            :meta="meta"
            :args="args"
        />
    </div>
</template>

<script setup>
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { /*computed,*/ ref, reactive, onBeforeMount } from 'vue';
import {useRoute} from "vue-router";
//import { getStatus, getDolzhfun, getNamedolzh, getDep } from '@/service/counteragent-service';


const gridRef = ref();
const isDataLoaded = ref(false)
/*const status = ref([]);
const statusComp = computed(() => status.value);
const dolzhfun = ref([]);
const dolzhfunComp = computed(() => dolzhfun.value);
const namedolzh = ref([]);
const namedolzhComp = computed(() => namedolzh.value);
const dep = ref([]);
const depComp = computed(() => dep.value);*/
const refreshDicts = async () => {
    /*const data4 = await getDep();
    if (data4 && data4.result) {
        dep.value = data4.data;
    }
    const data = await getStatus();
    if (data && data.result) {
        status.value = data.data;
    }
    const data2 = await getDolzhfun();
    if (data2 && data2.result) {
        dolzhfun.value = data2.data;
        console.log('dolzhfun.value', dolzhfun.value)
    }
    const data3 = await getNamedolzh();
    if (data3 && data3.result) {
        namedolzh.value = data3.data;
    }*/
};

onBeforeMount(async () => {
    await refreshDicts()
    isDataLoaded.value = true
});

const route = useRoute()

const meta = reactive ( {
    keyExpr: 'id',
    viewId: 'WidgetPayerEmployee',
    focusedRowEnabled: true,
    api: {
        select: 'counteragent./customer/card/widget/employee/get',
        save: 'counteragent./customer/card/widget/employee/save'
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        {
            dataField: 'pr_active',
            caption: 'Статус',
            /*readOnly: true,
            lookup: {
                dataSource: statusComp,
                displayExpr: 'abbr',
                valueExpr: 'pr_active'
            },*/
            width: 50,
            editor: { type: 'ai-drop-down', text: 'name_status' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text:'abbr',
                meta: {
                    keyExpr: 'pr_active',
                    columns: [{caption: 'pr_active', visible: false, dataField: 'pr_active'}, {caption: 'Статус', dataField: 'abbr'}],
                    api: {select: 'meta./meta/ai-grid-ro-select/get'},
                },
                args: {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'payer', table: 'kk_active', where: 'true', order: 'pr_active'}},
            },
        },
        {
            dataField: 'dep',
            caption: 'Подразделение',
            /*readOnly: true,
            lookup: {
                dataSource: depComp,
                displayExpr: 'sname',
                valueExpr: 'kodp'
            },*/
            width: 150,
            editor: { type: 'ai-drop-down', text: 'name_dep' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text:'sname',
                meta: {
                    keyExpr: 'kodp',
                    columns: [{caption: 'kodp', visible: false, dataField: 'kodp'}, {caption: 'Подразделение', dataField: 'sname'}],
                    api: {select: 'meta./meta/ai-grid-ro-select/get'},
                },
                args: {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'payer', table: 'kr_org', where: 'kod_ecls = 4 and kod_separator <= 2 and kod_parent is not null and tep_el is not null', order: 'sname'}},
            },
        },
        {
            dataField: 'kod_dolzhfun',
            caption: 'Должностная функция',
            /*readOnly: true,
            lookup: {
                dataSource: dolzhfunComp,
                displayExpr: 'name_fun',
                valueExpr: 'kod_dolzhfun'
            },*/
            width: 200,
            editor: { type: 'ai-drop-down', text: 'name_dolzhfun' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text:'name_fun',
                meta: {
                    keyExpr: 'kod_dolzhfun',
                    columns: [{caption: 'kod_dolzhfun', visible: false, dataField: 'kod_dolzhfun'}, {caption: 'Должностная функция', dataField: 'name_fun'}],
                    api: {select: 'meta./meta/ai-grid-ro-select/get'},
                },
                args: {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'payer', table: 'kk_dolzhfun', where: 'true', order: 'name_fun'}},
            },
        },
        {
            dataField: 'kod_namedolzh',
            caption: 'Должность',
            /*readOnly: true,
            lookup: {
                dataSource: namedolzhComp,
                displayExpr: 'name',
                valueExpr: 'kod_namedolzh'
            },*/
            width: 200,
            editor: { type: 'ai-drop-down', text: 'name_dolzh' },
            component: {
                path: 'components/ai-grid-ro/ai-grid-ro.vue',
                text:'name',
                meta: {
                    keyExpr: 'kod_namedolzh',
                    columns: [{caption: 'kod_namedolzh', visible: false, dataField: 'kod_namedolzh'}, {caption: 'Должность', dataField: 'name'}],
                    api: {select: 'meta./meta/ai-grid-ro-select/get'},
                },
                args: {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'payer', table: 'ks_namedolzh', where: 'true', order: 'name'}},
            },
        },
        {
            dataField: 'fio',
            caption: 'Ф.И.О.',
            dataType: 'string',
            width: 250,
        },
        {
            dataField: 'tab_nomer',
            caption: 'Табельный номер',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'fio_r',
            caption: 'Ф.И.О. в родительном падеже',
            dataType: 'string',
            width: 250,
        },
        {
            dataField: 'fio_d',
            caption: 'Ф.И.О. в дательном падеже',
            dataType: 'string',
            width: 250,
        },
        {
            dataField: 'fax',
            caption: 'Факс',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'place',
            caption: 'Место расположения факса',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'num_upd',
            caption: 'Признак наличия факсимиле',
            dataType: 'boolean',
            width: 150,
        },
        {
            dataField: 'name_file',
            caption: 'Имя файла факсимиле',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'd_birth',
            caption: 'Дата рождения',
            dataType: 'date',
            format: {type: 'shortDate'},
            width: 150,
        },
        {
            dataField: 'tel',
            caption: 'Телефон',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'm_tel',
            caption: 'Мобильный телефон',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'p_tel',
            caption: 'Прочие телефоны',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'remark',
            caption: 'Примечание',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'serial',
            caption: 'Серия паспорта',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'nomer',
            caption: 'Номер паспорта',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'kem',
            caption: 'Кем выдан паспорт',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'd_pasp',
            caption: 'Дата выдачи паспорта',
            dataType: 'date',
            width: 150,
        },
        {
            dataField: 'e_mail',
            caption: 'E-mail',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'namedolzh',
            caption: 'Должность в именительном падеже',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'namedolzh_r',
            caption: 'Должность в родительном падеже',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'adres_p',
            caption: 'Почтовый адрес',
            dataType: 'string',
            width: 200,
        },
        {
            dataField: 'inn',
            caption: 'ИНН',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'snils',
            caption: 'СНИЛС',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'inostran',
            caption: 'Иностранный гражданин',
            dataType: 'boolean',
            width: 150,
        },
        {
            dataField: 'pref',
            caption: 'Префикс СФ',
            dataType: 'string',
            width: 150,
        },
        {
            dataField: 'd_m',
            caption: 'Когда изменено',
            dataType: 'date',
            readOnly: true,
            width: 150,
        },
        {
            dataField: 'u_m',
            caption: 'Кем изменено',
            dataType: 'string',
            readOnly: true,
            width: 150,
        },
    ],
});

const args ={select: {kodp: route.params.id}, save: {kodp: route.params.id}}

</script>

